"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.userRaceBadgesSkipSelector = exports.userRaceBadgesHasNextSelector = exports.userRaceBadgesTotalCountSelector = exports.userRaceBadgesCountSelector = exports.userRaceBadgesDataSelector = exports.userRaceBadgesSelector = exports.userAllBadgesSkipSelector = exports.userAllBadgesHasNextSelector = exports.userAllBadgesTotalCountSelector = exports.userAllBadgesCountSelector = exports.userAllBadgesDataSelector = exports.userAllBadgesSelector = exports.userStandardBadgesSkipSelector = exports.userStandardBadgesHasNextSelector = exports.userStandardBadgesTotalCountSelector = exports.userStandardBadgesCountSelector = exports.userStandardBadgesDataSelector = exports.userStandardBadgesSelector = void 0;

var _reselect = require("reselect");

var badgesSelector = function badgesSelector(state) {
  return state.badges;
};

var userStandardBadgesSelector = (0, _reselect.createSelector)(badgesSelector, function (badgesState) {
  return badgesState.userStandardBadges;
});
exports.userStandardBadgesSelector = userStandardBadgesSelector;
var userStandardBadgesDataSelector = (0, _reselect.createSelector)(userStandardBadgesSelector, function (userStandardBadges) {
  return userStandardBadges ? userStandardBadges.data : null;
});
exports.userStandardBadgesDataSelector = userStandardBadgesDataSelector;
var userStandardBadgesMetaSelector = (0, _reselect.createSelector)(userStandardBadgesSelector, function (userStandardBadges) {
  return userStandardBadges ? userStandardBadges.meta : null;
});
var userStandardBadgesCountSelector = (0, _reselect.createSelector)(userStandardBadgesMetaSelector, function (userChallengeBadgesMeta) {
  return userChallengeBadgesMeta ? userChallengeBadgesMeta.count : null;
});
exports.userStandardBadgesCountSelector = userStandardBadgesCountSelector;
var userStandardBadgesTotalCountSelector = (0, _reselect.createSelector)(userStandardBadgesMetaSelector, function (userChallengeBadgesMeta) {
  return userChallengeBadgesMeta ? userChallengeBadgesMeta.badgeCount : null;
});
exports.userStandardBadgesTotalCountSelector = userStandardBadgesTotalCountSelector;
var userStandardBadgesHasNextSelector = (0, _reselect.createSelector)(userStandardBadgesMetaSelector, function (userChallengeBadgesMeta) {
  return userChallengeBadgesMeta ? !!userChallengeBadgesMeta.hasNext : false;
});
exports.userStandardBadgesHasNextSelector = userStandardBadgesHasNextSelector;
var userStandardBadgesSkipSelector = (0, _reselect.createSelector)(userStandardBadgesMetaSelector, function (userChallengeBadgesMeta) {
  return userChallengeBadgesMeta ? userChallengeBadgesMeta.skip : null;
});
exports.userStandardBadgesSkipSelector = userStandardBadgesSkipSelector;
var userAllBadgesSelector = (0, _reselect.createSelector)(badgesSelector, function (badgesState) {
  return badgesState.userAllBadges;
});
exports.userAllBadgesSelector = userAllBadgesSelector;
var userAllBadgesDataSelector = (0, _reselect.createSelector)(userAllBadgesSelector, function (userAllBadges) {
  return userAllBadges ? userAllBadges.data : null;
});
exports.userAllBadgesDataSelector = userAllBadgesDataSelector;
var userAllBadgesMetaSelector = (0, _reselect.createSelector)(userAllBadgesSelector, function (userAllBadges) {
  return userAllBadges ? userAllBadges.meta : null;
});
var userAllBadgesCountSelector = (0, _reselect.createSelector)(userAllBadgesMetaSelector, function (userChallengeBadgesMeta) {
  return userChallengeBadgesMeta ? userChallengeBadgesMeta.count : null;
});
exports.userAllBadgesCountSelector = userAllBadgesCountSelector;
var userAllBadgesTotalCountSelector = (0, _reselect.createSelector)(userAllBadgesMetaSelector, function (userChallengeBadgesMeta) {
  return userChallengeBadgesMeta ? userChallengeBadgesMeta.badgeCount : null;
});
exports.userAllBadgesTotalCountSelector = userAllBadgesTotalCountSelector;
var userAllBadgesHasNextSelector = (0, _reselect.createSelector)(userAllBadgesMetaSelector, function (userChallengeBadgesMeta) {
  return userChallengeBadgesMeta ? !!userChallengeBadgesMeta.hasNext : false;
});
exports.userAllBadgesHasNextSelector = userAllBadgesHasNextSelector;
var userAllBadgesSkipSelector = (0, _reselect.createSelector)(userAllBadgesMetaSelector, function (userChallengeBadgesMeta) {
  return userChallengeBadgesMeta ? userChallengeBadgesMeta.skip : null;
});
exports.userAllBadgesSkipSelector = userAllBadgesSkipSelector;
var userRaceBadgesSelector = (0, _reselect.createSelector)(badgesSelector, function (badgesState) {
  return badgesState.userRaceBadges;
});
exports.userRaceBadgesSelector = userRaceBadgesSelector;
var userRaceBadgesDataSelector = (0, _reselect.createSelector)(userRaceBadgesSelector, function (userRaceBadges) {
  return userRaceBadges ? userRaceBadges.data : null;
});
exports.userRaceBadgesDataSelector = userRaceBadgesDataSelector;
var userRaceBadgesMetaSelector = (0, _reselect.createSelector)(userRaceBadgesSelector, function (userRaceBadges) {
  return userRaceBadges ? userRaceBadges.meta : null;
});
var userRaceBadgesCountSelector = (0, _reselect.createSelector)(userRaceBadgesMetaSelector, function (userChallengeRacesMeta) {
  return userChallengeRacesMeta ? userChallengeRacesMeta.count : null;
});
exports.userRaceBadgesCountSelector = userRaceBadgesCountSelector;
var userRaceBadgesTotalCountSelector = (0, _reselect.createSelector)(userRaceBadgesMetaSelector, function (userChallengeRacesMeta) {
  return userChallengeRacesMeta ? userChallengeRacesMeta.badgeCount : null;
});
exports.userRaceBadgesTotalCountSelector = userRaceBadgesTotalCountSelector;
var userRaceBadgesHasNextSelector = (0, _reselect.createSelector)(userRaceBadgesMetaSelector, function (userChallengeRacesMeta) {
  return userChallengeRacesMeta ? !!userChallengeRacesMeta.hasNext : false;
});
exports.userRaceBadgesHasNextSelector = userRaceBadgesHasNextSelector;
var userRaceBadgesSkipSelector = (0, _reselect.createSelector)(userRaceBadgesMetaSelector, function (userChallengeRacesMeta) {
  return userChallengeRacesMeta ? userChallengeRacesMeta.skip : null;
});
exports.userRaceBadgesSkipSelector = userRaceBadgesSkipSelector;
var _default = {
  userStandardBadgesSelector: userStandardBadgesSelector,
  userStandardBadgesDataSelector: userStandardBadgesDataSelector,
  userStandardBadgesCountSelector: userStandardBadgesCountSelector,
  userStandardBadgesTotalCountSelector: userStandardBadgesTotalCountSelector,
  userStandardBadgesSkipSelector: userStandardBadgesSkipSelector,
  userStandardBadgesHasNextSelector: userStandardBadgesHasNextSelector,
  userAllBadgesSelector: userAllBadgesSelector,
  userAllBadgesDataSelector: userAllBadgesDataSelector,
  userAllBadgesCountSelector: userAllBadgesCountSelector,
  userAllBadgesTotalCountSelector: userAllBadgesTotalCountSelector,
  userAllBadgesSkipSelector: userAllBadgesSkipSelector,
  userAllBadgesHasNextSelector: userAllBadgesHasNextSelector,
  userRaceBadgesSelector: userRaceBadgesSelector,
  userRaceBadgesDataSelector: userRaceBadgesDataSelector,
  userRaceBadgesCountSelector: userRaceBadgesCountSelector,
  userRaceBadgesTotalCountSelector: userRaceBadgesTotalCountSelector,
  userRaceBadgesSkipSelector: userRaceBadgesSkipSelector,
  userRaceBadgesHasNextSelector: userRaceBadgesHasNextSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map